module.exports = __webpack_public_path__ + "media/wrong_move.d23fe55d.mp3";